import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { isInsideIframe, listenForParentAuth } from '@/shared/lib/authBridge'

// When running inside an iframe (dev preview), listen for auth tokens from parent.
// VITE_ALLOWED_PARENT_ORIGINS is a comma-separated list of origins allowed to send auth.
if (isInsideIframe()) {
  const allowedOrigins = (import.meta.env.VITE_ALLOWED_PARENT_ORIGINS as string || '')
    .split(',')
    .map(o => o.trim())
    .filter(Boolean)

  if (allowedOrigins.length > 0) {
    listenForParentAuth(allowedOrigins, () => {
      // Force re-render after receiving auth token
      window.location.reload()
    })
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
